// extracted by mini-css-extract-plugin
export default {"ring":"Cursor_ring__zuAy2","hideNative":"Cursor_hideNative__Taxbc"};